var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 0.166748C4.39795 0.166748 0.666992 3.89771 0.666992 8.50008C0.666992 13.1025 4.39795 16.8334 9.00033 16.8334C13.6027 16.8334 17.3337 13.1025 17.3337 8.50008C17.3337 3.89771 13.6027 0.166748 9.00033 0.166748ZM12.8672 5.35992C13.2207 5.65455 13.2685 6.18003 12.9738 6.53359L8.80718 11.5336C8.66171 11.7082 8.45125 11.8158 8.22455 11.8314C7.99786 11.8471 7.77458 11.7696 7.60644 11.6167L5.10644 9.34399C4.76589 9.0344 4.74079 8.50736 5.05038 8.16681C5.35997 7.82627 5.88701 7.80117 6.22756 8.11076L8.08379 9.79824L11.6935 5.46662C11.9881 5.11305 12.5136 5.06528 12.8672 5.35992Z",
    fill: "#65BD79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.e110add2ddcba857b55bd2a87988ff7c.svg";
export { ForwardRef as ReactComponent };